import { matchSteps } from "@/mocks/home";

export default function Matching() {
  return (
    <section id="matching" className="anchor-offset bg-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div className="flex flex-col gap-5">
            <span className="text-xs font-medium uppercase tracking-widest text-primary-600">缘分匹配</span>
            <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">
              让推荐更像「刚好合适」，而不是海量刷人
            </h2>
            <p className="text-sm leading-relaxed text-foreground-700 md:text-base">
              缘分匹配不追求数量，而是尽量贴近你的真实生活。它参考你的城市、年龄段、兴趣标签与相处偏好，
              把可能聊得来的人排到前面，再由你决定要不要迈出第一步。
            </p>
            <ol className="flex flex-col gap-4">
              {matchSteps.map((step) => (
                <li key={step.no} className="flex gap-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-500 font-heading text-sm text-background-50">
                    {step.no}
                  </span>
                  <div className="flex flex-col gap-1 pt-0.5">
                    <h3 className="font-heading text-base text-foreground-950 md:text-lg">{step.title}</h3>
                    <p className="text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <div className="flex flex-col gap-4">
            <div className="relative h-[280px] w-full overflow-hidden rounded-lg md:h-[360px]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20abstract%20artistic%20illustration%20of%20two%20silhouettes%20sitting%20across%20a%20small%20round%20table%20having%20a%20gentle%20conversation%2C%20soft%20sunset%20colors%20of%20coral%20rose%20and%20golden%20amber%2C%20minimal%20editorial%20style%2C%20smooth%20gradients%2C%20calm%20and%20romantic%20mood%2C%20no%20text&width=900&height=1000&seq=love-island-match-2026&orientation=portrait&alt=%E5%90%8C%E5%9F%8E%E4%BA%A4%E5%8F%8B%E7%BC%98%E5%88%86%E5%8C%B9%E9%85%8D%E5%9C%BA%E6%99%AF%E7%A4%BA%E6%84%8F%E5%9B%BE"
                alt="爱情岛缘分匹配场景示意图"
                className="h-full w-full object-top"
              />
            </div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="mb-1 flex items-center gap-2 text-accent-700">
                  <i className="ri-user-heart-line text-lg" aria-hidden="true"></i>
                  <span className="text-sm font-medium">兴趣契合优先</span>
                </div>
                <p className="text-sm leading-relaxed text-foreground-600">共同话题是破冰最快的方式，标签越具体，推荐越贴近。</p>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="mb-1 flex items-center gap-2 text-primary-700">
                  <i className="ri-equalizer-line text-lg" aria-hidden="true"></i>
                  <span className="text-sm font-medium">偏好由你掌握</span>
                </div>
                <p className="text-sm leading-relaxed text-foreground-600">可随时调整可见范围与推荐条件，不合适的人可以静默跳过。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}